import { LlmModel } from '../openai/openai';

export interface AutoGenGlobalSettings {
  groupChatSettings: GroupChatSettings;
  model: LlmModel;
}

export interface GroupChatSettings {
  maxRound: number;

  teamResourceContent?: string;

  adminName: string;
  functionCallFilter: boolean;
  speakerSelectionMethod: SpeakerSelectionMethod;
  allowRepeatSpeaker: boolean;
}

export enum SpeakerSelectionMethod {
  auto = 'auto',
  manual = 'manual',
  random = 'random',
  round_robin = 'round_robin',
}

export const defaultGlobalSettings: AutoGenGlobalSettings = {
  groupChatSettings: {
    maxRound: 5,
    adminName: 'Moderator',
    functionCallFilter: false,
    speakerSelectionMethod: SpeakerSelectionMethod.auto,
    allowRepeatSpeaker: true,
  },
  model: LlmModel.gpt35,
};

export interface AutoGenAgent {
  type?: AutoGenAgentType;

  agentPictureIndex?: number;

  name: string;
  prompt?: string;
  seed?: number;
  model?: LlmModel;

  position?: {
    x: number;
    y: number;
  };
}

export enum AutoGenAgentType {
  user = 'User',
  autogen = 'Agent',
  critic = 'Critic',
  moderator = 'Moderator',
}

export interface AutoGenInput {
  name?: string;
  type: AutoGenInputType;
  payload:
    | AutoGenInputPromptResponsePayload
    | AutoGenInputTextPayload
    | AutoGenInputSalesforcePayload
    | AutoGenInputParcelDataPayload
    | any;

  additionalInputPayloadList?: { type: AutoGenInputType; payload: any }[];

  inputModel?: LlmModel;

  ui?: AutoGenUi;
  uiPayload?: any;
  position?: {
    x: number;
    y: number;
  };
}

export enum ChatRunningMode {
  speed = 'Speed',
  performance = 'Performance',
}

export enum AutoGenInputType {
  text = 'text',
  image = 'image',
  math = 'math',
  file = 'file',
  csv = 'csv',
  salesforce = 'salesforce',
  parcelData = 'parcelData',
}

export enum AutoGenUi {
  chat = 'chat',
  text = 'text',
  form = 'form',
}

export interface AutoGenOutput {
  name?: string;

  type: AutoGenOutputType;

  nextSolutionIdList?: string[];

  model?: LlmModel;
  functionDefinition?: string;

  prompt?: string;

  payload?: any;

  position?: {
    x: number;
    y: number;
  };
}

export enum AutoGenOutputType {
  raw = 'raw',
  json = 'json',
  pdfFile = 'pdfFile',
  table = 'table',
  markdown = 'markdown',
}

export interface AutoGenInputImagePayload {
  imageUrl: string;
}

export interface AutoGenInputParcelDataPayload {
  parcelId: string;
}

export interface AutoGenInputSalesforcePayload {
  userName: string;
  password: string;
  securityToken: string;
  resourceName: string;
  query: string;
}

export interface AutoGenInputPromptResponsePayload {
  prompt: string;
  response: string;
}

export interface AutoGenInputFilePayload {
  fileName: string;
  content: string;
}

export interface AutoGenInputTextPayload {
  content: string;
}

export interface AutoGenInputMathPayload {
  content: string;
}
